"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingToNotificationReason = exports.notificationReasonToSetting = exports.isNotificationConfigured = exports.getVenueRemovalDetails = exports.getReasonDetails = exports.default = exports.allNotificationSettings = exports.acceptedVenueRemovalTypes = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _OrderNotificationReason = _interopRequireDefault(require("../enums/OrderNotificationReason"));
var _VenueRemovalNotificationTypes = _interopRequireDefault(require("../enums/VenueRemovalNotificationTypes"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var settingToNotificationReason = {
  notificationConditions_algoPaused: [_OrderNotificationReason.default.ALGO_RESTART, _OrderNotificationReason.default.ALGO_STOPPED,
  _OrderNotificationReason.default.MARKET_AVAIL, _OrderNotificationReason.default.NO_MARKET_AVAIL],
  notificationConditions_orderCancelled: [_OrderNotificationReason.default.CANCELED],
  notificationConditions_orderFilled: [_OrderNotificationReason.default.FILLED],
  notificationConditions_orderPlaced: [_OrderNotificationReason.default.PLACED],
  notificationConditions_venueExcludedFromAlgo: [_OrderNotificationReason.default.FEED_AVAIL, _OrderNotificationReason.default.FEED_NOT_AVAIL, _OrderNotificationReason.default.GATEWAY_AVAIL, _OrderNotificationReason.default.GATEWAY_NOT_AVAIL, _OrderNotificationReason.default.HUNG_ORDER, _OrderNotificationReason.default.HUNG_ORDER_RESOLVED],
  notificationConditions_venueRemovedFromAlgo: [_OrderNotificationReason.default.VENUE_REMOVAL]
};

exports.settingToNotificationReason = settingToNotificationReason;
var allNotificationSettings = Object.keys(settingToNotificationReason);

exports.allNotificationSettings = allNotificationSettings;
var notificationReasonToSetting = Object.entries(settingToNotificationReason).reduce((map, _ref) => {
  var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    setting = _ref2[0],
    types = _ref2[1];
  var _iterator = _createForOfIteratorHelper(types),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var type = _step.value;
      map[type] = setting;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return map;
}, {});

exports.notificationReasonToSetting = notificationReasonToSetting;
var getReasonDetails = {
  [_OrderNotificationReason.default.ALGO_RESTART]: _ref3 => {
    var qtyOrdered = _ref3.qtyOrdered,
      timestamp = _ref3.timestamp,
      executionType = _ref3.executionType;
    return {
      status: 'success',
      subject: 'Algo Restarted',
      desktopText: `Your ${qtyOrdered} ${executionType} restarted at ${timestamp}.`,
      orderDetailText: 'Algo restarted as EMS has become available again.'
    };
  },
  [_OrderNotificationReason.default.ALGO_STOPPED]: _ref4 => {
    var qtyOrdered = _ref4.qtyOrdered,
      timestamp = _ref4.timestamp,
      executionType = _ref4.executionType;
    return {
      status: 'warning',
      subject: 'Algo Paused',
      desktopText: `Your ${qtyOrdered} ${executionType} paused executing at ${timestamp}.`,
      orderDetailText: `Algo paused executing because the Omniex EMS is temporarily unavailable.`
    };
  },
  [_OrderNotificationReason.default.CANCELED]: _ref5 => {
    var executionType = _ref5.executionType,
      qtyOrdered = _ref5.qtyOrdered;
    return {
      status: 'info',
      subject: 'Order Canceled',
      desktopText: `Your ${executionType} order to ${qtyOrdered} was canceled.`
    };
  },
  [_OrderNotificationReason.default.FEED_AVAIL]: _ref6 => {
    var qtyOrdered = _ref6.qtyOrdered,
      venueName = _ref6.venueName,
      executionType = _ref6.executionType;
    return {
      status: 'success',
      subject: ` ${venueName} Re-added - Price Feed`,
      desktopText: `${venueName} has been re-added to your ${qtyOrdered} ${executionType}.`,
      orderDetailText: `${venueName} has been re-added as exchange price feeds have resumed.`
    };
  },
  [_OrderNotificationReason.default.FEED_NOT_AVAIL]: _ref7 => {
    var qtyOrdered = _ref7.qtyOrdered,
      venueName = _ref7.venueName,
      executionType = _ref7.executionType;
    return {
      status: 'warning',
      subject: `${venueName} Removed - Price Feed`,
      desktopText: `${venueName} has been temporarily removed from your ${qtyOrdered} ${executionType}.`,
      orderDetailText: `${venueName} has been temporarily removed due to missing or incomplete price feeds from the exchange.`
    };
  },
  [_OrderNotificationReason.default.FILLED]: _ref8 => {
    var executionType = _ref8.executionType,
      qtyOrdered = _ref8.qtyOrdered;
    return {
      status: 'info',
      subject: 'Order Completed',
      desktopText: `Your ${executionType} order to ${qtyOrdered} was completed.`
    };
  },
  [_OrderNotificationReason.default.GATEWAY_AVAIL]: _ref9 => {
    var qtyOrdered = _ref9.qtyOrdered,
      venueName = _ref9.venueName,
      executionType = _ref9.executionType;
    return {
      status: 'success',
      subject: ` ${venueName} Re-Added - Connection Restored`,
      desktopText: `${venueName} has been re-added from your ${qtyOrdered} ${executionType}.`,
      orderDetailText: `${venueName} has been re-added because the gateway is available again.`
    };
  },
  [_OrderNotificationReason.default.GATEWAY_NOT_AVAIL]: _ref10 => {
    var qtyOrdered = _ref10.qtyOrdered,
      venueName = _ref10.venueName,
      executionType = _ref10.executionType;
    return {
      status: 'warning',
      subject: `${venueName} Removed - Exchange Connection`,
      desktopText: `${venueName} has been temporarily removed from your ${qtyOrdered} ${executionType}.`,
      orderDetailText: `${venueName} has been temporarily removed due to exchange connectivity issues.`
    };
  },
  [_OrderNotificationReason.default.HUNG_ORDER]: _ref11 => {
    var qtyOrdered = _ref11.qtyOrdered,
      venueName = _ref11.venueName,
      executionType = _ref11.executionType;
    return {
      status: 'error',
      subject: `${venueName} Removed - Hung Order`,
      desktopText: `${venueName} has been temporarily removed from your ${qtyOrdered} ${executionType}.`,
      orderDetailText: `${venueName} has been temporarily removed while waiting on the status of a child order on the venue.`
    };
  },
  [_OrderNotificationReason.default.HUNG_ORDER_RESOLVED]: _ref12 => {
    var qtyOrdered = _ref12.qtyOrdered,
      venueName = _ref12.venueName,
      executionType = _ref12.executionType;
    return {
      status: 'success',
      subject: `${venueName} Re-added - Hung Order`,
      desktopText: `${venueName} has been re-added to your ${qtyOrdered} ${executionType}.`,
      orderDetailText: `${venueName} has been re-added as the child order on the venue has been reconciled.`
    };
  },
  [_OrderNotificationReason.default.MARKET_AVAIL]: _ref13 => {
    var qtyOrdered = _ref13.qtyOrdered,
      timestamp = _ref13.timestamp,
      executionType = _ref13.executionType;
    return {
      status: 'success',
      subject: 'Algo Resumed',
      desktopText: `Your ${qtyOrdered} ${executionType} resumed trading at ${timestamp}.`,
      orderDetailText: 'Algo resumed trading.'
    };
  },
  [_OrderNotificationReason.default.NO_MARKET_AVAIL]: _ref14 => {
    var qtyOrdered = _ref14.qtyOrdered,
      timestamp = _ref14.timestamp,
      executionType = _ref14.executionType;
    return {
      status: 'error',
      subject: 'Algo Paused',
      desktopText: `Your ${qtyOrdered} ${executionType} paused executing at ${timestamp}.`,
      orderDetailText: 'Algo paused executing because no pricing information was available on the selected venues.'
    };
  },
  [_OrderNotificationReason.default.PLACED]: _ref15 => {
    var executionType = _ref15.executionType,
      qtyOrdered = _ref15.qtyOrdered;
    return {
      status: 'info',
      subject: 'Order Accepted',
      desktopText: `Your ${executionType} order to ${qtyOrdered} was received.`
    };
  },
  [_OrderNotificationReason.default.VENUE_REMOVAL]: _ref16 => {
    var qtyOrdered = _ref16.qtyOrdered,
      venueName = _ref16.venueName,
      executionType = _ref16.executionType;
    return {
      status: 'warning',
      desktopText: `${venueName} was removed from your ${qtyOrdered} ${executionType}.`
    };
  }
};

exports.getReasonDetails = getReasonDetails;
var getCustomVenueRemovalDetails = {
  [_VenueRemovalNotificationTypes.default.IncorrectQuantity]: _ref17 => {
    var venueName = _ref17.venueName;
    return {
      subject: `${venueName} Removed - Invalid Quantity`,
      orderDetailText: `${venueName} was removed due to an invalid specified quantity.`
    };
  },
  [_VenueRemovalNotificationTypes.default.InsufficientFunds]: _ref18 => {
    var venueName = _ref18.venueName;
    return {
      subject: ` ${venueName} Removed - Insufficient Funds`,
      orderDetailText: `${venueName} was removed due to insufficient funds.`
    };
  },
  [_VenueRemovalNotificationTypes.default.InvalidCreds]: _ref19 => {
    var venueName = _ref19.venueName;
    return {
      subject: `${venueName} Removed - Invalid API Key`,
      orderDetailText: `${venueName} was removed due to an invalid API key.`
    };
  },
  [_VenueRemovalNotificationTypes.default.InvalidPrice]: _ref20 => {
    var venueName = _ref20.venueName;
    return {
      subject: `${venueName} Removed - Invalid Limit Price`,
      orderDetailText: `${venueName} was removed due to an invalid limit price.`
    };
  },
  [_VenueRemovalNotificationTypes.default.MisconfiguredApiKeys]: _ref21 => {
    var venueName = _ref21.venueName;
    return {
      subject: `${venueName} Removed - Invalid API Key`,
      orderDetailText: `${venueName} was removed due to an invalid API key.`
    };
  },
  [_VenueRemovalNotificationTypes.default.PriceExceedsBand]: _ref22 => {
    var venueName = _ref22.venueName;
    return {
      subject: `${venueName} Removed - Price Band`,
      orderDetailText: `${venueName} rejected the order and was removed because the limit price was too far off market.`
    };
  },
  [_VenueRemovalNotificationTypes.default.RestrictedMarket]: _ref23 => {
    var instrumentSymbol = _ref23.instrumentSymbol,
      venueName = _ref23.venueName;
    return {
      subject: `${venueName} Removed - Restricted Market`,
      orderDetailText: `${venueName} was removed because ${instrumentSymbol} is a restricted market on venue.`
    };
  },
  [_VenueRemovalNotificationTypes.default.ThrottleLimit]: _ref24 => {
    var venueName = _ref24.venueName;
    return {
      subject: `${venueName} Removed - Rate Limit`,
      orderDetailText: `${venueName} was removed due to an exceeded rate limit.`
    };
  },
  [_VenueRemovalNotificationTypes.default.UnsupportedInstrument]: _ref25 => {
    var instrumentSymbol = _ref25.instrumentSymbol,
      venueName = _ref25.venueName;
    return {
      subject: `${venueName} Removed - Unsupported Instrument`,
      orderDetailText: `${venueName} was removed because it does not support ${instrumentSymbol}.`
    };
  },
  [_VenueRemovalNotificationTypes.default.UntradableAmount]: _ref26 => {
    var venueName = _ref26.venueName;
    return {
      subject: `${venueName} Removed - Insufficient Allocation`,
      orderDetailText: `${venueName} was removed due to insufficient allocation remaining on venue.`
    };
  },
  [_VenueRemovalNotificationTypes.default.VenueNotSupported]: _ref27 => {
    var venueName = _ref27.venueName;
    return {
      subject: `${venueName} Removed - Unsupported Venue`,
      orderDetailText: `${venueName} is not a supported venue and therefore removed from your order.`
    };
  }
};

var acceptedVenueRemovalTypes = Object.values(_VenueRemovalNotificationTypes.default);

exports.acceptedVenueRemovalTypes = acceptedVenueRemovalTypes;
var genericVenueRemovalTypes = acceptedVenueRemovalTypes.filter(t => !getCustomVenueRemovalDetails[t]);

var getGenericVenueRemovalDetails = _ref28 => {
  var executionType = _ref28.executionType,
    qtyOrdered = _ref28.qtyOrdered,
    text = _ref28.text,
    venueName = _ref28.venueName;
  return {
    subject: `${venueName} Removed`,
    orderDetailText: `${venueName} was removed from your ${qtyOrdered} ${executionType}. Reason: ${text}.`,
    desktopText: `${venueName} was removed from your ${qtyOrdered} ${executionType}. Reason: ${text}.`
  };
};

var getDefaultVenueRemovalDetails = _ref29 => {
  var venueName = _ref29.venueName;
  return {
    subject: `${venueName} Removed - Unspecified Reasons`,
    orderDetailText: `${venueName} was removed for unspecified reasons.`
  };
};

var getVenueRemovalDetails = function getVenueRemovalDetails() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return genericVenueRemovalTypes.includes(text) ? getGenericVenueRemovalDetails : getCustomVenueRemovalDetails[text] || getDefaultVenueRemovalDetails;
};

exports.getVenueRemovalDetails = getVenueRemovalDetails;
var isNotificationConfigured = notification => (notification === null || notification === void 0 ? void 0 : notification.reason) in getReasonDetails && ((notification === null || notification === void 0 ? void 0 : notification.reason) !== _OrderNotificationReason.default.VENUE_REMOVAL || acceptedVenueRemovalTypes.includes(notification === null || notification === void 0 ? void 0 : notification.text));
exports.isNotificationConfigured = isNotificationConfigured;
var _default = {
  acceptedVenueRemovalTypes,
  allNotificationSettings,
  getReasonDetails,
  getVenueRemovalDetails,
  isNotificationConfigured,
  notificationReasonToSetting,
  settingToNotificationReason
};
exports.default = _default;